import React, { Suspense, lazy } from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

const PrivacyPolicies = lazy(
  () =>
    import(/* webpackChunkName: "privacy-policies" */ './pages/PrivacyPolicies')
);
const ThirdSharingChecklist = lazy(
  () =>
    import(
      /* webpackChunkName: "third-sharing-checklist" */ './pages/ThirdSharingChecklist'
    )
);

/****************************免责申明 *******************************/
const Disclaimerlangwen = lazy(
  () => import('./pages/disclaimer/aiclass-langwen')
);
const Disclaimerlangwentmp = lazy(() => import('./pages/disclaimer/langwen'));
const Disclaimermath = lazy(() => import('./pages/disclaimer/aiclass-math'));
const Disclaimergrammar = lazy(
  () => import('./pages/disclaimer/aiclass-grammar')
);
const Disclaimerreadandwrite = lazy(
  () => import('./pages/disclaimer/aiclass-readandwrite')
);
const Disclaimersynclass = lazy(
  () => import('./pages/disclaimer/aiclass-synclass')
);
const Disclaimershumeiyun = lazy(
  () => import('./pages/disclaimer/shumeiyun-namibox')
);

/****************************隐私政策 *******************************/
const Privacylangwen = lazy(() => import('./pages/privacy/aiclass-langwen'));
const Privacylangwentmp = lazy(() => import('./pages/privacy/langwen'));
const Privacymath = lazy(() => import('./pages/privacy/aiclass-math'));
const Privacygrammar = lazy(() => import('./pages/privacy/aiclass-grammar'));
const Privacyreadandwrite = lazy(
  () => import('./pages/privacy/aiclass-readandwrite')
);
const Privacysynclass = lazy(() => import('./pages/privacy/aiclass-synclass'));
const Privacyshumeiyun = lazy(
  () => import('./pages/privacy/shumeiyun-namibox')
);
const Privacynamibox = lazy(
  /* webpackChunkName: "privacy-namibox" */ () =>
    import('./pages/privacy/namibox')
);
const Privacypbox = lazy(() => import('./pages/privacy/pbox'));

/****************************用户协议 *******************************/
const Licenselangwen = lazy(() => import('./pages/license/aiclass-langwen'));
const Licenselangwentmp = lazy(() => import('./pages/license/langwen'));
const Licensemath = lazy(() => import('./pages/license/aiclass-math'));
const Licensegrammar = lazy(() => import('./pages/license/aiclass-grammar'));
const Licensereadandwrite = lazy(
  () => import('./pages/license/aiclass-readandwrite')
);
const Licensesynclass = lazy(() => import('./pages/license/aiclass-synclass'));
const Licenseshumeiyun = lazy(
  () => import('./pages/license/shumeiyun-namibox')
);
const Licensespbox = lazy(() => import('./pages/license/pbox'));

/****************************隐私简明版 *******************************/
const PrivacyPolicieslangwen = lazy(
  () => import('./pages/privacy-policies/aiclass-langwen')
);
const PrivacyPolicieslangwentmp = lazy(
  () => import('./pages/privacy-policies/langwen')
);
const PrivacyPoliciesmath = lazy(
  () => import('./pages/privacy-policies/aiclass-math')
);
const PrivacyPoliciesgrammar = lazy(
  () => import('./pages/privacy-policies/aiclass-grammar')
);
const PrivacyPoliciesreadandwrite = lazy(
  () => import('./pages/privacy-policies/aiclass-readandwrite')
);
const PrivacyPoliciessynclass = lazy(
  () => import('./pages/privacy-policies/aiclass-synclass')
);
const PrivacyPoliciesshumeiyun = lazy(
  () => import('./pages/privacy-policies/shumeiyun-namibox')
);
const PrivacyPoliciespbox = lazy(() => import('./pages/privacy-policies/pbox'));

/****************************第三方共享清单 *******************************/
const TSChecklistlangwen = lazy(
  () => import('./pages/third-sharing-checklist/aiclass-langwen')
);
const TSChecklistlangwentmp = lazy(
  () => import('./pages/third-sharing-checklist/langwen')
);
const TSChecklistmath = lazy(
  () => import('./pages/third-sharing-checklist/aiclass-math')
);
const TSChecklistgrammar = lazy(
  () => import('./pages/third-sharing-checklist/aiclass-grammar')
);
const TSChecklistreadandwrite = lazy(
  () => import('./pages/third-sharing-checklist/aiclass-readandwrite')
);
const TSChecklistsynclass = lazy(
  () => import('./pages/third-sharing-checklist/aiclass-synclass')
);
const TSChecklistshumeiyun = lazy(
  () => import('./pages/third-sharing-checklist/shumeiyun-namibox')
);
const TSChecklistpbox = lazy(
  () => import('./pages/third-sharing-checklist/pbox')
);

const App: React.FC = () => {
  return (
    <>
      <Router>
        <Suspense fallback={<div />}>
          <Switch>
            <Redirect exact path="/" to={{ pathname: '/privacy-policies' }} />
            <Route
              exact
              path="/privacy-policies"
              component={() => <PrivacyPolicies />}
            />
            <Route
              exact
              path="/third-sharing-checklist"
              component={() => <ThirdSharingChecklist />}
            />

            {/* 免责申明 */}
            <Route
              exact
              path="/disclaimer/aiclass-langwen"
              component={() => <Disclaimerlangwen />}
            />
            <Route
              exact
              path="/disclaimer/langwen"
              component={() => <Disclaimerlangwentmp />}
            />
            <Route
              exact
              path="/disclaimer/aiclass-math"
              component={() => <Disclaimermath />}
            />
            <Route
              exact
              path="/disclaimer/aiclass-grammar"
              component={() => <Disclaimergrammar />}
            />
            <Route
              exact
              path="/disclaimer/aiclass-readandwrite"
              component={() => <Disclaimerreadandwrite />}
            />
            <Route
              exact
              path="/disclaimer/aiclass-synclass"
              component={() => <Disclaimersynclass />}
            />
            <Route
              exact
              path="/disclaimer/shumeiyun-namibox"
              component={() => <Disclaimershumeiyun />}
            />

            {/* 隐私政策 */}
            <Route
              exact
              path="/privacy/aiclass-langwen"
              component={() => <Privacylangwen />}
            />
            <Route
              exact
              path="/privacy/langwen"
              component={() => <Privacylangwentmp />}
            />
            <Route
              exact
              path="/privacy/aiclass-math"
              component={() => <Privacymath />}
            />
            <Route
              exact
              path="/privacy/aiclass-grammar"
              component={() => <Privacygrammar />}
            />
            <Route
              exact
              path="/privacy/aiclass-readandwrite"
              component={() => <Privacyreadandwrite />}
            />
            <Route
              exact
              path="/privacy/aiclass-synclass"
              component={() => <Privacysynclass />}
            />
            <Route
              exact
              path="/privacy/shumeiyun-namibox"
              component={() => <Privacyshumeiyun />}
            />
            <Route
              exact
              path="/privacy/namibox"
              component={() => <Privacynamibox />}
            />
            <Route
              exact
              path="/privacy/pbox"
              component={() => <Privacypbox />}
            />

            {/* 用户协议 */}
            <Route
              exact
              path="/license/aiclass-langwen"
              component={() => <Licenselangwen />}
            />
            <Route
              exact
              path="/license/langwen"
              component={() => <Licenselangwentmp />}
            />
            <Route
              exact
              path="/license/aiclass-math"
              component={() => <Licensemath />}
            />
            <Route
              exact
              path="/license/aiclass-grammar"
              component={() => <Licensegrammar />}
            />
            <Route
              exact
              path="/license/aiclass-readandwrite"
              component={() => <Licensereadandwrite />}
            />
            <Route
              exact
              path="/license/aiclass-synclass"
              component={() => <Licensesynclass />}
            />
            <Route
              exact
              path="/license/shumeiyun-namibox"
              component={() => <Licenseshumeiyun />}
            />
            <Route
              exact
              path="/license/pbox"
              component={() => <Licensespbox />}
            />

            {/* 隐私简明版 */}
            <Route
              exact
              path="/privacy-policies/aiclass-langwen"
              component={() => <PrivacyPolicieslangwen />}
            />
            <Route
              exact
              path="/privacy-policies/langwen"
              component={() => <PrivacyPolicieslangwentmp />}
            />
            <Route
              exact
              path="/privacy-policies/aiclass-math"
              component={() => <PrivacyPoliciesmath />}
            />
            <Route
              exact
              path="/privacy-policies/aiclass-grammar"
              component={() => <PrivacyPoliciesgrammar />}
            />
            <Route
              exact
              path="/privacy-policies/aiclass-readandwrite"
              component={() => <PrivacyPoliciesreadandwrite />}
            />
            <Route
              exact
              path="/privacy-policies/aiclass-synclass"
              component={() => <PrivacyPoliciessynclass />}
            />
            <Route
              exact
              path="/privacy-policies/shumeiyun-namibox"
              component={() => <PrivacyPoliciesshumeiyun />}
            />
            <Route
              exact
              path="/privacy-policies/pbox"
              component={() => <PrivacyPoliciespbox />}
            />

            {/* 第三方信息共享清单 */}
            <Route
              exact
              path="/third-sharing-checklist/aiclass-langwen"
              component={() => <TSChecklistlangwen />}
            />
            <Route
              exact
              path="/third-sharing-checklist/langwen"
              component={() => <TSChecklistlangwentmp />}
            />
            <Route
              exact
              path="/third-sharing-checklist/aiclass-math"
              component={() => <TSChecklistmath />}
            />
            <Route
              exact
              path="/third-sharing-checklist/aiclass-grammar"
              component={() => <TSChecklistgrammar />}
            />
            <Route
              exact
              path="/third-sharing-checklist/aiclass-readandwrite"
              component={() => <TSChecklistreadandwrite />}
            />
            <Route
              exact
              path="/third-sharing-checklist/aiclass-synclass"
              component={() => <TSChecklistsynclass />}
            />
            <Route
              exact
              path="/third-sharing-checklist/shumeiyun-namibox"
              component={() => <TSChecklistshumeiyun />}
            />
            <Route
              exact
              path="/third-sharing-checklist/pbox"
              component={() => <TSChecklistpbox />}
            />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};
export default App;
